import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// MDXEditor's own theme CSS (toolbar, content-area typography, dialogs) —
// Vite's library build bundles every CSS import reachable from the package's
// component tree (including `@mdxeditor/editor/style.css`, pulled in by
// MarkdownEditor.tsx) into this one file, named after the JS entry point.
// Without it the rich text editor renders with no toolbar/content styling.
import '@kevlarcon/pages/dist/index.css';
// Structural/layout CSS for HeroCollage/HeroSplit/HeroCentered/HeroStat/Stats
// — see `@kevlarcon/pages`' docs/section-types.md §2.10. Imported before
// ocen.css so ocen.css's own colors/fonts/radii still win the cascade.
import '@kevlarcon/pages/dist/styles/sections.css';
// The OCEN visual system is authored CSS (custom properties + component
// classes), imported after Tailwind so its base element styles win over
// Tailwind's preflight.
import './styles/ocen.css';
// The SGOKit platform identity. Fully scoped under `.sgk-site`, so it coexists
// with ocen.css (the tenant demo) without collision.
import './styles/sgokit.css';
import App from './App';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
